import { Button } from "@mui/material";

import AlertConfirm from "commons/ui/alert/AlertConfirm";
import DataTableSimple from "commons/ui/datatable/DataTableSimple";
import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";
import Paper from "commons/ui/Paper";

import ShowroomTableFilters from "components/subComponents/ShowroomTableFilters";

import useShowroomList from "hooks/list/useShowroomList";

function ElencoShowroom() {
    const showroomListHook = useShowroomList();

    const { navigateToNewShowroom, alertConfirmHook, dataTableHook } = showroomListHook;

    return (
        <GridColumn>
            <AlertConfirm alertConfirmHook={alertConfirmHook} />

            <Paper className={"table-with-filters"}>
                <ShowroomTableFilters showroomListHook={showroomListHook} />

                <DataTableSimple dataTableHook={dataTableHook} dontUsePaper />
            </Paper>

            <GridRow justifyContent={"right"}>
                <GridItem className={"button-under-paper"}>
                    <Button variant={"contained"} onClick={navigateToNewShowroom}>
                        Nuovo Showroom
                    </Button>
                </GridItem>
            </GridRow>
        </GridColumn>
    );
}

export default ElencoShowroom;
